import { get, request } from '@/util/http'

export const getList = () => {
  return request({
    url: '/sys/SysValueConfig/getList',
    method: 'post',
    params: {
    }
  })
}
export const remove = (ids) => {
  return request({
    url: '/sys/SysValueConfig/getList',
    method: 'post',
    params: {
      ids
    }
  })
}

export const add = (row) => {
  return request({
    url: '/sys/SysValueConfig/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/sys/SysValueConfig/submit',
    method: 'post',
    data: row
  })
}

export const getMenu = (id) => {
  return request({
    url: '/sys/SysValueConfig/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const tree = (category) => get('/sys/menu/tree', { category })

export const getLazyList = (parentId, params) => {
  return request({
    url: '/sys/menu/lazy-list',
    method: 'get',
    params: {
      ...params,
      parentId
    }
  })
}

export const getLazyMenuList = (parentId, params) => {
  return request({
    url: '/sys/menu/lazy-menu-list',
    method: 'get',
    params: {
      ...params,
      parentId
    }
  })
}
